import { Pipe, PipeTransform } from '@angular/core';
import { ContractStatus } from '../../interfaces/contract';

@Pipe({
  name: 'contractStatus'
})
export class ContractStatusPipe implements PipeTransform {

  transform(value: ContractStatus): string {
    switch (value) {
      case ContractStatus.ACTIVE:
        return 'Ativo';
      case ContractStatus.TERMINATED:
        return 'Encerrado';
      case ContractStatus.COMPLETED:
        return 'Finalizado';
      default:
        return '---';
    }
  }

}
